// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"47":"client","818":"auth"}[chunkId] + "." + {"47":"3eadd08d","818":"7011d4b7"}[chunkId] + ".css";
};